import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { jobsCategorySelected } from "../../features/jobs/jobsSlice";

function Sidebar() {
  const dispatch = useDispatch();
  // const status = useSelector((state) => state.jobs);
  // const { jobsCategory } = status;
  // console.log(jobsCategory);

  // const filterFeaturedHandler = (e) => {
  //   e.preventDefault();
  //   dispatch(featureSelected("featured"));
  // };
  const showAllAvailableJobHandler = () => {
    dispatch(jobsCategorySelected("all"));
  };
  const showAllInternshipJobHandler = () => {
    dispatch(jobsCategorySelected("internship"));
  };
  const showAllFullTimeJobHandler = () => {
    dispatch(jobsCategorySelected("fullTime"));
  };
  const showAllRemoteJobHandler = () => {
    dispatch(jobsCategorySelected("remote"));
  };

  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <button
              onClick={showAllAvailableJobHandler}
              className="main-menu menu-active"
              id="lws-alljobs-menu"
            >
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </button>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <button
                  onClick={showAllInternshipJobHandler}
                  className="sub-menu"
                  id="lws-internship-menu"
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                  　Internship
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  onClick={showAllFullTimeJobHandler}
                  id="lws-fulltime-menu"
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                  　Full Time
                </button>
              </li>
              <li>
                <button
                  className="sub-menu"
                  onClick={showAllRemoteJobHandler}
                  id="lws-remote-menu"
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                  　Remote
                </button>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/AddNewJob" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus"></i>
              <span> Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Sidebar;
